module.exports = __webpack_public_path__ + "img/slide-icon.04b550e8.svg";